function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9jcm9zcy1zbWFsbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvaWNvbnMvY3Jvc3Mtc21hbGwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIENyb3NzU21hbGwoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBhcmlhLWxhYmVsPVwiQ3Jvc3Mgc21hbGxcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIxLjczMSAxMS4yNjlhLjkxNS45MTUgMCAwMTAgMS4yOTZsLTMuOTM1IDMuOTM0IDMuOTM1IDMuOTM2YS45MTUuOTE1IDAgMTEtMS4yOTYgMS4yOTZMMTYuNSAxNy43OTVsLTMuOTM1IDMuOTM2YS45MTQuOTE0IDAgMDEtMS4yOTYgMCAuOTE1LjkxNSAwIDAxMC0xLjI5NmwzLjkzNC0zLjkzNi0zLjkzNC0zLjkzNGEuOTE1LjkxNSAwIDExMS4yOTYtMS4yOTZsMy45MzUgMy45MzQgMy45MzUtMy45MzRhLjkxNi45MTYgMCAwMTEuMjk2IDB6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ3Jvc3NTbWFsbC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENyb3NzU21hbGw7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function CrossSmall(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Cross small",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M21.731 11.269a.915.915 0 010 1.296l-3.935 3.934 3.935 3.936a.915.915 0 11-1.296 1.296L16.5 17.795l-3.935 3.936a.914.914 0 01-1.296 0 .915.915 0 010-1.296l3.934-3.936-3.934-3.934a.915.915 0 111.296-1.296l3.935 3.934 3.935-3.934a.916.916 0 011.296 0z",
    fill: primaryColor
  }));
}

CrossSmall.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default CrossSmall;